import React from 'react';
import PropTypes from 'prop-types';
import { IFrameVideo } from '../../../components/IFrameVideo/IFrameVideo';
import './PortalVideo.scss';

export const PortalVideo = function (props) {
  const { anchor, videoUrl } = props;

  return (
    <portal-video id={anchor}>
      <div className="row portal-section">
        <div className="columns small-11 small-centered medium-8 medium-centered">
          <IFrameVideo src={videoUrl} aspectRatio="widescreen" />
        </div>
      </div>
    </portal-video>
  );
};

PortalVideo.displayName = 'PortalVideo';
PortalVideo.propTypes = {
  anchor: PropTypes.string.isRequired,
  videoUrl: PropTypes.string.isRequired,
};
